export default {
  default: "#000",
  blue: "#35395A",
  purple: "#6A617F",
  brown: "#684c38",
};
